$(document).ready(function(){
    $(document).foundation();


    if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }


    // esc key action
    $(document).keyup(function(e) 
    {
        if (e.keyCode == 27) { // Esc
            var nav_span = $(".nav-span");
            nav_span.removeClass("nav-cross");
            nav_span.addClass("nav-lines");
            $('body').removeClass('nav-toggle-is-active');
            $('#featuredInfoWindow').slideUp(); // hide the faux infowindow on maps
            $('#searchContainer').removeClass("active");
        }
    });


    var $emailCaptureModal = $('#emailCaptureModal');


    jQuery(document).bind('gform_confirmation_loaded', function(event, formId){
        //$emailCaptureModal.foundation('close');
    });

    $emailCaptureModal.find( '.close-reveal-modal' ).click(function () {
        $emailCaptureModal.foundation('close');
    });



});